module.exports = __webpack_public_path__ + "static/media/hero-packs.a8e83f35.png";